import axios from "axios";
import Cookies from "js-cookie";

export const api = axios.create({
  baseURL: '/api/', // Utiliser les routes API Next.js locales
})

// Attach token to every request if available
api.interceptors.request.use(
  (config) => {
    const token = Cookies.get('token_auth')

    if (token) {
      config.headers.Authorization = `Token ${token}`
    }

    // If sending FormData, let the browser set the correct multipart boundary
    try {
      /* eslint-disable  @typescript-eslint/no-explicit-any */
      const maybeFormData: any = (config as any).data
      if (typeof FormData !== 'undefined' && maybeFormData instanceof FormData) {
        if (config.headers) {
          // Remove any preset content-type so the browser sets it
          delete (config.headers as any)['Content-Type']
          delete (config.headers as any)['content-type']
        }
      }
    } catch {}

    return config
  },
  (error: Error) => Promise.reject(error)
)

// Refresh logic for 401 responses
let isRefreshing = false
/* eslint-disable  @typescript-eslint/no-explicit-any */
let failedQueue: any[] = []

/* eslint-disable  @typescript-eslint/no-explicit-any */
function processQueue(error: any, token: string | null = null) {
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error)
    } else {
      prom.resolve(token)
    }
  })

  failedQueue = []
}

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config

    if (
      (error.response?.status === 401 || error.response?.status === 403) &&
      !originalRequest._retry &&
      Cookies.get('refresh_auth')
    ) {
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject })
        })
          /* eslint-disable  @typescript-eslint/no-explicit-any */
          .then((token: any) => {
            originalRequest.headers['Authorization'] = "Token " + token
            return api(originalRequest)
          })
          .catch((err) => Promise.reject(err))
      }

      originalRequest._retry = true
      isRefreshing = true

      try {
        const refresh = Cookies.get('refresh_auth')
        const res = await axios.post('/api/auth/refresh/', {
          refresh_token: refresh
        })
        const { access_token, refresh_token } = res.data
        // js-cookie expects days for expires
        Cookies.set('token_auth', access_token, { expires: 7 })
        Cookies.set('refresh_auth', refresh_token, { expires: 7 })

        api.defaults.headers.Authorization = `Token ${access_token}`
        processQueue(null, access_token)

        return api(originalRequest)
      } catch (err) {
        processQueue(err, null)
        Cookies.remove('token_auth')
        Cookies.remove('refresh_auth')
        Cookies.remove('user_auth')
        return Promise.reject(err)
      } finally {
        isRefreshing = false
      }
    }

    return Promise.reject(error)
  }
)


